import { Box, Container, Grid, Modal, Typography } from "@mui/material";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import uploadImage from "../../../image/wmremove-transformed-Photorooms.jpg";
import {
  barClubEditRequest,
  barClubResetState,
  barClubViewRequest,
} from "../../../redux/barclub/BarClubAction";
import { wholesalerSearchViewAllRequest } from "../../../redux/wholesaler/WholesalerAction";
import "../../../style/style.css";
import { StyledContainer, styles } from "../../components/formStyles";
import CustomButton from "../../constant/commonButton";
import {
  convertImageToBase64MultiImage,
  handleFileChangeMultiImage,
  handleProofChangeMultiImage,
  convertProofToBase64MultiImage,
  removeImage,
  removeProofImage,
  removeBarImage,
  removeBarProofImage,
} from "../../constant/commonFileUpload";
import {
  convertTo24HourFormat,
  formatToAMPM,
} from "../../constant/commonTimeFormat";
import ReusableFormFields from "../../constant/reusableFormFields";
import { APP_LINKS } from "../../global/wholeSalerMenuItems";
import { mapBackendMessage } from "../../notification/BackendMessage";
import CommonDialog from "../../notification/Dialogbox";
import CommonSnackbar from "../../notification/Snackbar";
import CloseIcon from "@mui/icons-material/Close";
import pdf from "../../../image/pdf.jpg";
import ImagePreviewDialog from "../../constant/commonImageDialog";

const EditClub = () => {
  const {
    register,
    handleSubmit,
    setValue,
    control,
    setError,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();

  const [imagePreview, setImagePreview] = useState([]);
  const [proofPreview, setProofPreview] = useState([]);
  const [selectedFile, setSelectedFile] = useState([]);
  const [proofSelected, setProofSelected] = useState([]);
  const [imageFileName, setImageFileName] = useState("");
  const [proofFileName, setProofFileName] = useState("");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(true);
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState([]);

  //separate existing and new images
  const [existingImageUrls, setExistingImageUrls] = useState([]);
  const [newImageBase64, setNewImageBase64] = useState([]);
  const [existingProofUrls, setExistingProofUrls] = useState([]);
  const [newProofBase64, setNewProofBase64] = useState([]);

  // Map
  const [openMap, setOpenMap] = useState(false);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState("");
  const GOOGLE_MAPS_API_KEY = "AIzaSyCvQUUv4zUJSZdBGgDb38rZZakE7qyutZ8";
  const [isImageOnlySave, setIsImageOnlySave] = useState(false);

  const barClubState = useSelector(
    (state) => state?.barClub?.viewBarClub?.data || {}
  );
  const barClubList = barClubState || [];
  const editBarClubState = useSelector((state) => state.barClub?.editBarClub);
  const wholesalerViewAllState = useSelector(
    (state) => state?.wholesaler?.viewAllSearchWholesaler || {}
  );
  const wholesalerList = wholesalerViewAllState?.data?.data || [];

  const WholesalerId = useSelector(
    (state) => state?.values?.loginValues?.[0]?.wholesaler_id
  );

  useEffect(() => {
    dispatch(wholesalerSearchViewAllRequest());
  }, [dispatch]);

  const inputFields = [
    {
      name: "reg_no",
      label: "Register No",
      readOnly: true,
    },
    {
      name: "name",
      label: "Name",
    },
    {
      name: "first_name",
      label: "First Name",
    },
    {
      name: "last_name",
      label: "Last Name",
    },
    {
      name: "email",
      label: "Email Address",
      rules: {
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email format",
        },
      },
    },
    {
      name: "contact",
      label: "Phone No",
      rules: {
        required: "Phone No is required",
        pattern: {
          value: /^\d{8,}$/,
          message: "Invalid Phone Number",
        },
      },
    },
    {
      name: "address",
      label: "Address",
      size: "extraLarge",
    },
    {
      name: "google_map_location",
      label: "Google Map Location",
    },
    {
      name: "latitude",
      label: "Latitude",
    },
    {
      name: "longitude",
      label: "Longitude",
    },
    {
      name: "postal_code",
      label: "Postal Code",
      rules: {
        required: "Postal Code is required",
        pattern: {
          value: /^[0-9]+$/,
          message: "Only numbers are allowed",
        },
      },
    },
    {
      name: "shop_open_and_close_time",
      label: "Shop Time",
      type: "group",
      fields: [
        {
          name: "open_time",
          label: "Shop Opening Time",
          type: "time",
        },
        {
          name: "close_time",
          label: "Shop Closing Time",
          type: "time",
        },
      ],
    },
    {
      name: "status",
      label: "Status",
      type: "select",
      options: [
        { value: "1", label: "Active" },
        { value: "2", label: "Inactive" },
      ],
      defaultValue: wholesalerList?.status,
      rules: { required: "Status is Required" },
    },
  ];

  const handleImageUpload = (event) => {
    handleFileChangeMultiImage(
      event,
      setNewImageBase64,
      setImagePreview,
      setImageFileName,
      showSnackbar
    );
  };

  const handleProofUpload = (event) => {
    handleProofChangeMultiImage(
      event,
      setNewProofBase64,
      setProofPreview,
      setProofFileName,
      showSnackbar,
      setValue
    );
  };

  const handleCancel = () => {
    navigate(APP_LINKS.BARCLUBAGGREGATION);
  };

  useEffect(() => {
    if (id) {
      dispatch(barClubViewRequest(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (barClubState && Object.keys(barClubState).length > 0) {
      setExistingImageUrls([]);
      setImagePreview([]);
      setExistingProofUrls([]);
      setProofPreview([]);
      setNewImageBase64([]);
      setNewProofBase64([]);

      setValue("reg_no", barClubState?.reg_no || "");
      setValue("first_name", barClubState?.first_name || "");
      setValue("last_name", barClubState?.last_name || "");
      setValue("address", barClubState?.address || "");
      setValue("email", barClubState?.email || "");
      setValue("contact", barClubState?.contact || "");
      setValue("name", barClubState?.name || "");
      setValue("google_map_location", barClubState?.google_map_location || "");
      setValue("latitude", barClubState?.latitude || "");
      setValue("longitude", barClubState?.longitude || "");
      setValue("postal_code", barClubState?.postal_code || "");
      setValue(
        "shop_open_and_close_time",
        barClubState?.shop_open_and_close_time || ""
      );
      setValue("status", barClubState?.status || "");

      const processImages = async () => {
        const imageUrls = Array.isArray(barClubState?.bar_image)
          ? barClubState.bar_image.filter(
              (img) => img && img !== null && img !== uploadImage
            )
          : barClubState?.bar_image && barClubState.bar_image !== uploadImage
          ? [barClubState.bar_image]
          : [];

        // Remove duplicates
        const uniqueImageUrls = [...new Set(imageUrls)];

        if (uniqueImageUrls.length > 0) {
          try {
            const convertImagePromises = uniqueImageUrls.map(async (url) => {
              return await convertImageToBase64MultiImage(url);
            });

            const base64Images = await Promise.all(convertImagePromises);

            const validBase64Images = base64Images.filter(
              (img) => img && img !== null
            );

            setExistingImageUrls(validBase64Images);
            setImagePreview(uniqueImageUrls);
          } catch (error) {
            console.error("Error processing images:", error);
            showSnackbar("Error loading some images", "warning");
          }
        }
      };

      const processProofs = async () => {
        const proofUrls = Array.isArray(barClubState?.govt_id_image)
          ? barClubState.govt_id_image.filter(
              (img) => img && img !== null && img !== uploadImage
            )
          : barClubState?.govt_id_image &&
            barClubState.govt_id_image !== uploadImage
          ? [barClubState.govt_id_image]
          : [];

        // Remove duplicates
        const uniqueProofUrls = [...new Set(proofUrls)];

        if (uniqueProofUrls.length > 0) {
          try {
            const convertProofPromises = uniqueProofUrls.map(async (url) => {
              return await convertProofToBase64MultiImage(url);
            });

            const base64ProofImages = await Promise.all(convertProofPromises);

            const validBase64ProofImages = base64ProofImages.filter(
              (img) => img && img !== null
            );

            setExistingProofUrls(validBase64ProofImages);
            setProofPreview(uniqueProofUrls);
          } catch (error) {
            console.error("Error processing proof images:", error);
            showSnackbar("Error loading some proof images", "warning");
          }
        }
      };

      processImages();
      processProofs();
    }
  }, [barClubState, setValue]);

  useEffect(() => {
    if (barClubState?.shop_open_and_close_time) {
      const timeParts = barClubState.shop_open_and_close_time.split(" to ");

      if (timeParts.length === 2) {
        setValue("open_time", convertTo24HourFormat(timeParts[0]), {
          shouldDirty: true,
          shouldValidate: true,
        });
        setValue("close_time", convertTo24HourFormat(timeParts[1]), {
          shouldDirty: true,
          shouldValidate: true,
        });
      } else {
        setValue("open_time", "", { shouldDirty: true, shouldValidate: true });
        setValue("close_time", "", { shouldDirty: true, shouldValidate: true });
      }
    }
  }, [barClubState?.shop_open_and_close_time, setValue]);

  // Map handlers
  const handleOpenMap = () => {
    setOpenMap(true);
  };

  const handleCloseMap = () => {
    setOpenMap(false);
    setLatitude(null);
    setLongitude(null);
    setLoading(false);
    setAddress("");
  };

  const fetchAddress = async (lat, lng) => {
    setLoading(true);
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGLE_MAPS_API_KEY}`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      if (data.results && data.results.length > 0) {
        const formattedAddress = data.results[0].formatted_address;
        setAddress(formattedAddress);
        setValue("address", formattedAddress);
      } else {
        setAddress("Address not found");
        setValue("address", "Address not found");
      }
    } catch (error) {
      console.error("Error fetching address:", error);
      setAddress("Error fetching address");
      setValue("address", "Error fetching address");
    } finally {
      setLoading(false);
    }
  };

  const handleMapClick = (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    setLatitude(lat);
    setLongitude(lng);
    setValue("latitude", lat);
    setValue("longitude", lng);
    setValue(
      "google_map_location",
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGLE_MAPS_API_KEY}`
    );
    fetchAddress(lat, lng);
  };

  const onSubmit = async (data) => {
    const {
      bar_image,
      govt_id_image,
      WholeSaler,
      created_at,
      prof_image,
      profile_image,
      ...filteredData
    } = data;

    let barImages = [...existingImageUrls];
    let govtImages = [...existingProofUrls];

    if (newImageBase64.length > 0) {
      barImages = [...barImages, ...newImageBase64];
    }

    if (newProofBase64.length > 0) {
      govtImages = [...govtImages, ...newProofBase64];
    }

    // Remove duplicates and null values
    barImages = [...new Set(barImages.filter((img) => img && img !== null))];
    govtImages = [...new Set(govtImages.filter((img) => img && img !== null))];

    const editRequestData = {
      ...filteredData,
      id,
      shop_open_and_close_time: `${formatToAMPM(
        filteredData.open_time
      )} to ${formatToAMPM(filteredData.close_time)}`,
      wholesaler_id: WholesalerId,
      bar_img_url: barImages,
      govt_img_url: govtImages,
    };

    dispatch(barClubEditRequest(id, editRequestData));
  };

  const handleImage = () => {
    if (newImageBase64.length > 0 || existingImageUrls.length > 0) {
      const combinedImages = [...existingImageUrls, ...newImageBase64];
      const uniqueImages = [
        ...new Set(combinedImages.filter((img) => img && img !== null)),
      ];

      const data = {
        ...barClubList,
        bar_img_url: uniqueImages,
      };
      setIsImageOnlySave(true);
      onSubmit(data);
    } else {
      showSnackbar("Please choose a file before saving.", "error");
    }
  };

  const proofImage = () => {
    if (newProofBase64.length > 0 || existingProofUrls.length > 0) {
      const combinedProofs = [...existingProofUrls, ...newProofBase64];
      const uniqueProofs = [
        ...new Set(combinedProofs.filter((img) => img && img !== null)),
      ];

      const data = {
        ...barClubList,
        govt_img_url: uniqueProofs,
      };
      setIsImageOnlySave(true);
      onSubmit(data);
    } else {
      showSnackbar("Please choose a file before saving.", "error");
    }
  };

  const handleRemoveImage = (index) => {
    const newImagePreview = [...imagePreview];
    const newExistingUrls = [...existingImageUrls];

    newImagePreview.splice(index, 1);

    if (index < existingImageUrls.length) {
      newExistingUrls.splice(index, 1);
    } else {
      const newImageIndex = index - existingImageUrls.length;
      const newImageBase64Copy = [...newImageBase64];
      newImageBase64Copy.splice(newImageIndex, 1);
      setNewImageBase64(newImageBase64Copy);
    }

    setImagePreview(newImagePreview);
    setExistingImageUrls(newExistingUrls);

    if (newImageBase64.length <= 1) {
      setImageFileName("");
    }
  };

  const handleRemoveProof = (index) => {
    const newProofPreview = [...proofPreview];
    const newExistingProofUrls = [...existingProofUrls];

    newProofPreview.splice(index, 1);

    if (index < existingProofUrls.length) {
      newExistingProofUrls.splice(index, 1);
    } else {
      const newProofIndex = index - existingProofUrls.length;
      const newProofBase64Copy = [...newProofBase64];
      newProofBase64Copy.splice(newProofIndex, 1);
      setNewProofBase64(newProofBase64Copy);
    }

    setProofPreview(newProofPreview);
    setExistingProofUrls(newExistingProofUrls);

    if (newProofBase64.length <= 1) {
      setProofFileName("");
    }
  };

  const handleEditBarClubResponse = () => {
    if (editBarClubState?.error) {
      const errorFields = editBarClubState.errorFields || {};
      if (Object.keys(errorFields).length > 0) {
        Object.keys(errorFields).forEach((field) => {
          setError(field, {
            type: "manual",
            message: errorFields[field],
          });
        });
      } else {
        const customMessage = mapBackendMessage(
          editBarClubState?.errormessage ||
            "An error occurred while updating the Bar/Club."
        );
        setDialogMessage(customMessage);
        setIsSuccess(false);
        setDialogOpen(true);
        dispatch(barClubResetState());
        dispatch(barClubViewRequest(id));
      }
    } else if (editBarClubState?.success) {
      if (isImageOnlySave) {
        showSnackbar("Image/Proof saved successfully!", "success");
        dispatch(barClubResetState());
        dispatch(barClubViewRequest(id));
      } else {
        setDialogMessage("Bar/Club updated successfully");
        setIsSuccess(true);
        setDialogOpen(true);
        navigate(APP_LINKS.BARCLUBAGGREGATION);
      }

      dispatch(barClubResetState());
      setIsImageOnlySave(false);
    }
  };

  useEffect(() => {
    handleEditBarClubResponse();
  }, [editBarClubState]);

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleImageClick = (file, isPdf = false) => {
    if (isPdf) {
      window.open(file, "_blank");
    } else if (file !== uploadImage) {
      setSelectedImage(file);
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage(null);
  };

  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={5}>
            <Box>
              <Typography
                variant="h5"
                gutterBottom
                sx={styles.title}
                className="headingTable"
              >
                <h1>Update Bar/Club Details</h1>
              </Typography>
              <Typography variant="p" gutterBottom sx={styles.photoHeading}>
                Upload Images of Bar/Club
              </Typography>
            </Box>
            <Box>
              <StyledContainer>
                <Grid container spacing={6}>
                  {imagePreview.length > 0 ? (
                    imagePreview.map((preview, index) => (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={2}
                        xl={2}
                        key={`image-${index}-${preview}`} // Better key
                      >
                        <Box sx={styles.imageUploadClosePosition}>
                          <img
                            src={preview}
                            alt={`Image ${index + 1}`}
                            width={80}
                            height={80}
                            style={styles.imageUploadCloseContain}
                            onClick={() => handleImageClick(preview)}
                          />
                          <button
                            type="button"
                            onClick={() => handleRemoveImage(index)}
                            style={styles.imageUploadClose}
                          >
                            <CloseIcon fontSize="small" />
                          </button>
                        </Box>
                      </Grid>
                    ))
                  ) : (
                    <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
                      <img
                        src={uploadImage}
                        alt="Default Upload Image"
                        width={80}
                        height={80}
                        style={styles.image}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} sm={12} md={12} lg={10} xl={10}>
                    <Typography
                      variant="p"
                      gutterBottom
                      sx={styles.photoContent}
                    >
                      Upload Actual Photos of Bar/Club, size less than 2MB
                    </Typography>
                    <Box sx={styles.fileButtonContainer}>
                      <CustomButton
                        variant="outlined"
                        component="label"
                        size="small"
                        buttonStyle="chooseFileButton"
                      >
                        Choose File
                        <input
                          type="file"
                          hidden
                          multiple
                          accept="image/*"
                          onChange={handleImageUpload}
                        />
                      </CustomButton>
                      <CustomButton
                        variant="contained"
                        size="small"
                        buttonStyle="fileNameButton"
                        selectedFile={Boolean(newImageBase64.length > 0)}
                      >
                        {imageFileName || "No File Chosen"}
                      </CustomButton>
                    </Box>
                    <Box sx={styles.saveButtonContainer}>
                      <CustomButton
                        text="Save"
                        buttonStyle="saveButton"
                        onClick={handleImage}
                        size="small"
                      >
                        Save
                      </CustomButton>
                    </Box>
                  </Grid>
                </Grid>
              </StyledContainer>
              <Typography variant="body2" gutterBottom sx={styles.note}>
                <span style={{ color: "red" }}>Note:</span> Only JPEG or PNG
                format is supported <span style={{ color: "red" }}>*</span>
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={5}>
            <Box sx={styles.fileBoxContainer}>
              <Typography variant="p" gutterBottom sx={styles.photoHeading}>
                Upload Govt ID Proof Of Bar/club
              </Typography>
              <StyledContainer>
                <Grid container spacing={6}>
                  {proofPreview.length > 0 &&
                  proofPreview.some((file) => file) ? (
                    proofPreview.map((fileObj, index) => {
                      const fileUrl =
                        typeof fileObj === "string" ? fileObj : fileObj?.url;
                      const isPdf =
                        typeof fileObj === "string"
                          ? fileObj.toLowerCase().endsWith(".pdf")
                          : fileObj?.isPdf ?? false;

                      return (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={4}
                          lg={2}
                          xl={2}
                          key={`proof-${index}-${fileUrl}`} // Better key
                        >
                          <Box sx={styles.imageUploadClosePosition}>
                            {isPdf ? (
                              <img
                                src={pdf}
                                alt={`PDF ${index + 1}`}
                                width={80}
                                height={80}
                                style={styles.imageUploadCloseContain}
                                onClick={() => {
                                  handleImageClick(fileUrl, true);
                                }}
                              />
                            ) : (
                              <img
                                src={fileUrl}
                                alt={`Proof ${index + 1}`}
                                width={80}
                                height={80}
                                style={styles.imageUploadCloseContain}
                                onClick={() => {
                                  handleImageClick(fileUrl, false);
                                }}
                              />
                            )}
                            <button
                              type="button"
                              onClick={() => handleRemoveProof(index)}
                              style={styles.imageUploadClose}
                            >
                              <CloseIcon fontSize="small" />
                            </button>
                          </Box>
                        </Grid>
                      );
                    })
                  ) : (
                    <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
                      <img
                        src={uploadImage}
                        alt="Default Upload Image"
                        width={80}
                        height={80}
                        style={styles.image}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} sm={12} md={12} lg={10} xl={10}>
                    <Typography
                      variant="p"
                      gutterBottom
                      sx={styles.photoContent}
                    >
                      Upload Actual Photos of Proof, size less than 2MB
                    </Typography>
                    <Box sx={styles.fileButtonContainer}>
                      <CustomButton
                        text="Choose File"
                        variant="outlined"
                        component="label"
                        size="small"
                        buttonStyle="chooseFileButton"
                      >
                        Choose File
                        <input
                          type="file"
                          hidden
                          multiple
                          accept="image/*,.pdf"
                          onChange={handleProofUpload}
                        />
                      </CustomButton>
                      <CustomButton
                        variant="contained"
                        size="small"
                        buttonStyle="fileNameButton"
                        selectedFile={Boolean(newProofBase64.length > 0)}
                      >
                        {proofFileName || "No File Chosen"}
                      </CustomButton>
                    </Box>
                    <Box sx={styles.saveButtonContainer}>
                      <CustomButton
                        text="Save"
                        buttonStyle="saveButton"
                        onClick={proofImage}
                        size="small"
                      >
                        Save
                      </CustomButton>
                    </Box>
                  </Grid>
                </Grid>
              </StyledContainer>
            </Box>
            <Typography variant="body2" gutterBottom sx={styles.note}>
              <span style={{ color: "red" }}>Note:</span> Only JPEG, PDF & PNG
              format is supported <span style={{ color: "red" }}>*</span>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
            <ReusableFormFields
              inputFields={inputFields}
              control={control}
              errors={errors}
              register={register}
              setValue={setValue}
              required={true}
              onFieldClick={handleOpenMap}
            />
            <Box sx={styles.submitGap}>
              <Grid container spacing={2} item xs={12}>
                <Grid item xs={6}>
                  <CustomButton
                    text="Submit"
                    size="medium"
                    type="submit"
                    buttonStyle="StyledButton"
                    disabled={editBarClubState?.inProgress}
                    loading={editBarClubState?.inProgress}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomButton
                    text="Cancel"
                    variant="contained"
                    size="medium"
                    fullWidth
                    buttonStyle="style1"
                    onClick={handleCancel}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </form>
      <CommonSnackbar
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
      <CommonDialog
        open={dialogOpen}
        isSuccess={isSuccess}
        onClose={handleDialogClose}
        messageSuccess={dialogMessage}
        messageError={dialogMessage}
      />

      {/* Popup Dialog */}
      <ImagePreviewDialog
        open={open}
        onClose={handleClose}
        selectedImage={selectedImage}
        proofSelected={proofSelected}
      />

      <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY}>
        <form onSubmit={handleSubmit(onSubmit)}>
          {/* Modal for Map */}
          <Modal
            open={openMap}
            onClose={handleCloseMap}
            aria-labelledby="map-modal-title"
            aria-describedby="map-modal-description"
          >
            <Box
              sx={{
                p: 2,
                bgcolor: "white",
                borderRadius: "8px",
                maxWidth: "600px",
                mx: "auto",
                mt: "10%",
              }}
            >
              <h2 id="map-modal-title">Select Location</h2>
              <GoogleMap
                mapContainerStyle={{ width: "100%", height: "400px" }}
                center={{ lat: 12.9716, lng: 77.5946 }}
                zoom={10}
                onClick={handleMapClick}
              >
                {latitude && longitude && (
                  <Marker
                    position={{
                      lat: parseFloat(latitude),
                      lng: parseFloat(longitude),
                    }}
                  />
                )}
              </GoogleMap>
            </Box>
          </Modal>
        </form>
      </LoadScript>
    </Container>
  );
};

export default EditClub;
